import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldableWithIndex from "../Data.FoldableWithIndex/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Specular$dDom$dBuilder$dClass from "../Specular.Dom.Builder.Class/index.js";
import * as Specular$dDom$dWidgets$dInput from "../Specular.Dom.Widgets.Input/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
const selectView = dictMonadWidget => dictEq => config => valueD => dictMonadWidget.MonadReplace2().MonadCleanup1().Monad0().Bind1().bind(dictMonadWidget.MonadDomBuilder0()[
  "elDynAttrNS'"
](Data$dMaybe.Nothing)("select")(config.attributes)((() => {
  const $0 = dictMonadWidget.MonadReplace2().MonadCleanup1().Monad0().Applicative0();
  return Data$dFoldableWithIndex.foldableWithIndexArray.foldrWithIndex(i => {
    const $1 = $0.Apply0();
    return x => {
      const $2 = dictMonadWidget.MonadDomBuilder0().elAttr("option")((() => {
        const $2 = Data$dShow.showIntImpl(i);
        return (() => {
          const $3 = {};
          $3.value = $2;
          return $3;
        })();
      })())(dictMonadWidget.MonadDomBuilder0().text(config.display(x)));
      return b => $1.apply($1.Functor0().map(v => x$1 => x$1)($2))(b);
    };
  })($0.pure())(config.options);
})()))(v => {
  const $0 = v._1;
  return dictMonadWidget.MonadReplace2().MonadCleanup1().Monad0().Bind1().bind(Specular$dFRP$dWeakDynamic.subscribeWeakDyn_((() => {
    const $1 = dictMonadWidget.MonadFRP1().MonadEffect0();
    const $2 = dictMonadWidget.MonadReplace2().MonadCleanup1();
    return {MonadEffect0: () => $1, MonadCleanup1: () => $2};
  })())(value => {
    const $1 = Data$dArray.findIndex(dictEq.eq(value))(config.options);
    if ($1.tag === "Nothing") { return () => {}; }
    if ($1.tag === "Just") {
      const $2 = Specular$dDom$dWidgets$dInput.setTextInputValue($0)(Data$dShow.showIntImpl($1._1));
      return () => {$2();};
    }
    $runtime.fail();
  })(valueD))(() => dictMonadWidget.MonadReplace2().MonadCleanup1().Monad0().Bind1().bind(Specular$dDom$dBuilder$dClass.domEventWithSample((() => {
    const $1 = dictMonadWidget.MonadFRP1().MonadEffect0();
    const $2 = dictMonadWidget.MonadReplace2().MonadCleanup1();
    return {MonadEffect0: () => $1, MonadCleanup1: () => $2};
  })())(v1 => Specular$dDom$dWidgets$dInput.getTextInputValue($0))("change")($0))(domChanged => dictMonadWidget.MonadReplace2().MonadCleanup1().Monad0().Applicative0().pure(Specular$dFRP$dBase.filterMapEvent((() => {
    const $1 = Data$dArray.index(config.options);
    return a => {
      const $2 = Data$dInt.fromString(a);
      if ($2.tag === "Just") { return $1($2._1); }
      if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    };
  })())(domChanged))));
});
const selectInput = dictMonadWidget => config => dictMonadWidget.MonadReplace2().MonadCleanup1().Monad0().Bind1().bind(dictMonadWidget.MonadDomBuilder0()["elDynAttrNS'"](Data$dMaybe.Nothing)("select")(config.attributes)((() => {
  const $0 = dictMonadWidget.MonadReplace2().MonadCleanup1().Monad0().Applicative0();
  return Data$dFoldableWithIndex.foldableWithIndexArray.foldrWithIndex(i => {
    const $1 = $0.Apply0();
    return x => {
      const $2 = dictMonadWidget.MonadDomBuilder0().elAttr("option")((() => {
        const $2 = Data$dShow.showIntImpl(i);
        return (() => {
          const $3 = {};
          $3.value = $2;
          return $3;
        })();
      })())(dictMonadWidget.MonadDomBuilder0().text(config.display(x)));
      return b => $1.apply($1.Functor0().map(v => x$1 => x$1)($2))(b);
    };
  })($0.pure())(config.options);
})()))(v => {
  const $0 = v._1;
  return dictMonadWidget.MonadReplace2().MonadCleanup1().Monad0().Bind1().bind(dictMonadWidget.MonadFRP1().MonadEffect0().liftEffect(Specular$dDom$dWidgets$dInput.setTextInputValue($0)(Data$dShow.showIntImpl(config.initialValueIndex))))(() => dictMonadWidget.MonadReplace2().MonadCleanup1().Monad0().Bind1().bind(Specular$dDom$dBuilder$dClass.domEventWithSample((() => {
    const $1 = dictMonadWidget.MonadFRP1().MonadEffect0();
    const $2 = dictMonadWidget.MonadReplace2().MonadCleanup1();
    return {MonadEffect0: () => $1, MonadCleanup1: () => $2};
  })())(v1 => Specular$dDom$dWidgets$dInput.getTextInputValue($0))("change")($0))(domChanged => {
    const $1 = dictMonadWidget.MonadFRP1().MonadEffect0();
    const $2 = dictMonadWidget.MonadReplace2().MonadCleanup1();
    return Specular$dFRP$dBase.foldDyn({MonadEffect0: () => $1, MonadCleanup1: () => $2})(x => v$1 => x)(config.options[config.initialValueIndex])(Specular$dFRP$dBase.filterMapEvent((() => {
      const $3 = Data$dArray.index(config.options);
      return a => {
        const $4 = Data$dInt.fromString(a);
        if ($4.tag === "Just") { return $3($4._1); }
        if ($4.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      };
    })())(domChanged));
  }));
});
export {selectInput, selectView};
